module.exports = __webpack_public_path__ + "static/media/arrow-down.ddc6e482.svg";